import React from 'react';
import { Smartphone, Globe, TrendingUp } from 'lucide-react';
interface DentosFooterProps {
  onNavigate: (page: 'home' | 'knowledge' | 'tools' | 'research' | 'dental-kids' | 'logo') => void;
}
export function DentosFooter({
  onNavigate
}: DentosFooterProps) {
  const handleNavClick = (e: React.MouseEvent, page: 'home' | 'knowledge' | 'tools' | 'research' | 'dental-kids' | 'logo', href?: string) => {
    e.preventDefault();
    onNavigate(page);
    if (href && page === 'home') {
      setTimeout(() => {
        const element = document.querySelector(href);
        if (element) element.scrollIntoView({
          behavior: 'smooth'
        });else window.scrollTo(0, 0);
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  };
  return <footer className="bg-[#0F1E3C] text-white py-16 border-t border-gray-800" data-id="element-6">
      <div className="container mx-auto px-4 md:px-6" data-id="element-7">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-8">
          {/* Col 1 */}
          <div data-id="element-9">
            <div className="mb-6 cursor-pointer flex items-center gap-2" onClick={() => onNavigate('home')} data-id="element-10">
              <svg width="28" height="28" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-11">
                <rect x="8" y="8" width="4" height="24" rx="2" fill="#00C2D4" data-id="element-12" />
                <rect x="14" y="18" width="4" height="14" rx="2" fill="#00C2D4" data-id="element-13" />
                <rect x="20" y="13" width="4" height="19" rx="2" fill="#00C2D4" data-id="element-14" />
                <rect x="26" y="8" width="4" height="24" rx="2" fill="#00C2D4" data-id="element-15" />
              </svg>
              <span style={{
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 800,
              fontSize: '18px',
              letterSpacing: '3px',
              color: '#FFFFFF'
            }} data-id="element-16">
                DENTOS
              </span>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed" data-id="element-17">
              Профессиональная платформа знаний для владельцев стоматологий
              Казахстана
            </p>
            <a href="https://wa.me/77055405178" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#00C2D4] hover:text-white transition-colors" data-id="element-18">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" className="mr-2 flex-shrink-0" data-id="element-19">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-20" />
              </svg>
              Написать в WhatsApp
            </a>
          </div>

          {/* Col 2 */}
          <div data-id="element-21">
            <h4 className="font-bold text-lg mb-6" data-id="element-22">Навигация</h4>
            <ul className="space-y-3 text-gray-400" data-id="element-23">
              <li data-id="element-24">
                <a href="#" onClick={e => handleNavClick(e, 'home')} className="hover:text-[#00C2D4] transition-colors" data-id="element-25">
                  Главная
                </a>
              </li>
              <li data-id="element-26">
                <a href="#" onClick={e => handleNavClick(e, 'knowledge')} className="hover:text-[#00C2D4] transition-colors" data-id="element-27">
                  База знаний
                </a>
              </li>
              <li data-id="element-28">
                <a href="#" onClick={e => handleNavClick(e, 'research')} className="hover:text-[#00C2D4] transition-colors" data-id="element-29">
                  Исследования
                </a>
              </li>
              <li data-id="element-30">
                <a href="#" onClick={e => handleNavClick(e, 'tools')} className="hover:text-[#00C2D4] transition-colors" data-id="element-31">
                  Инструменты
                </a>
              </li>
              <li data-id="element-32">
                <a href="#" onClick={e => handleNavClick(e, 'dental-kids')} className="hover:text-[#00C2D4] transition-colors" data-id="element-33">
                  Dental Kids
                </a>
              </li>
            </ul>
          </div>

          {/* Col 3 */}
          <div data-id="element-34">
            <h4 className="font-bold text-lg mb-6" data-id="element-35">Инструменты</h4>
            <ul className="space-y-3 text-gray-400" data-id="element-36">
              {['Калькулятор потерь', 'Калькулятор LTV', 'Диагностика бизнеса', 'Калькулятор окупаемости'].map(item => <li key={item} data-id="element-37">
                  <a href="#" onClick={e => handleNavClick(e, 'tools')} className="hover:text-[#00C2D4] transition-colors" data-id="element-38">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Col 4 */}
          <div data-id="element-39">
            <h4 className="font-bold text-lg mb-6" data-id="element-40">Контакты</h4>
            <ul className="space-y-3 text-gray-400" data-id="element-41">
              <li className="flex items-center" data-id="element-42">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="#00C2D4" className="mr-3 flex-shrink-0" data-id="element-43">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-44" />
                </svg>
                <a href="https://wa.me/77055405178" target="_blank" rel="noopener noreferrer" className="hover:text-[#00C2D4] transition-colors" data-id="element-45">
                  +7 705 540 5178
                </a>
              </li>
              <li className="flex items-center" data-id="element-46">
                <Globe size={18} className="mr-3 text-[#00C2D4]" data-id="element-47" /> Email
              </li>
              <li className="flex items-center" data-id="element-48">
                <TrendingUp size={18} className="mr-3 text-[#00C2D4]" data-id="element-49" /> Астана,
                Казахстан
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center text-gray-500 text-sm" data-id="element-50">
          <p data-id="element-51">© 2026 DENTOS. Все права защищены.</p>
          <p className="mt-2 md:mt-0 hover:text-white cursor-pointer transition-colors" data-id="element-52">
            Политика конфиденциальности
          </p>
        </div>
      </div>
    </footer>;
}